import React, { useEffect,useState } from 'react';
import moment from 'moment';
import {
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
  } from "@mui/material";
  import ButtonPolicy from "src/components/Permission/ButtonPolicy"; 
  import { restructureJsonForAlisDialog } from "src/util/utilFunctions";

/**
 * Generic dialog that given an array of fields called fields and jsonData called dataToDisplay it displays all the data in a dialog
 * @param {*open} open control variable
 * @param {*onClose} funtion that is called on close 
 * @param {title} title of the Dialog
 * @param {fields} array of the fields to show in the dialog  
 * @param {dataToDisplay} json body to choose the fields from
 * @param {leftButtonTitle} title of optional button for additional functionality
 * @param {leftButtonFunction} functionality of optional button
 * @returns 
 */
function AlisDialog({ open, onClose, title, dataToDisplay, fields, leftButtonTitle, leftButtonFunction }) {
    const [refinedData,setRefinedDataToDisplay]=useState(null)
    useEffect((
    )=>{
        setRefinedDataToDisplay(restructureJsonForAlisDialog(fields,dataToDisplay))
    },[dataToDisplay])
  return (
    <Dialog open={open} onClose={onClose}>
      {refinedData && (
        <>
        {title&&
          <DialogTitle>{title}</DialogTitle>}
          <DialogContent>
            {Object.keys(refinedData).map((key, index) => (
              <p key={index}>
                {key}: {refinedData[key]}
              </p>
            ))}
          </DialogContent>
          <DialogActions>
            <div className="closeDialog">
              <ButtonPolicy
                variant="contained"
                onClick={onClose}
                policy="ticket.view"
              >
                Close
              </ButtonPolicy>
            </div>
            {leftButtonFunction && leftButtonFunction && (
            <div className="closeDialog">
              <ButtonPolicy
                variant="contained"
                onClick={()=> leftButtonFunction(dataToDisplay.alisId)}
                policy="ticket.view"
              >
                {leftButtonTitle}
              </ButtonPolicy>
            </div>)}
          </DialogActions>
        </>
      )}
    </Dialog>
  );
}

export default AlisDialog;
